var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecording1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.005,
    height: 15,
    viewBox: "0 0 15.005 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recording1",
    transform: "translate(65.114 739.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M-57.614-735.8a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0-57.614-735.8Zm1.672,4.727a.941.941,0,0,1-.941.941h-1.456a.94.94,0,0,1-.665-.276.94.94,0,0,1-.275-.665v-1.456a.94.94,0,0,1,.94-.94h1.456a.94.94,0,0,1,.665.275.94.94,0,0,1,.276.665Z",
    fill: "#0052cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M-53.109-739.3h-9.01a3,3,0,0,0-3,2.995v9.01a2.994,2.994,0,0,0,2.995,3h9.01a2.994,2.994,0,0,0,2.121-.875,2.994,2.994,0,0,0,.879-2.12v-9.01a3,3,0,0,0-3-3Zm-4.5,12.5a5,5,0,0,1-5-5,5,5,0,0,1,5-5,5,5,0,0,1,5,5,5,5,0,0,1-5,5Z",
    fill: "#0052cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording1);
export default __webpack_public_path__ + "static/media/Recording1.5b731a150452a7d84f41f21ccb820f9e.svg";
export { ForwardRef as ReactComponent };